<template>
  <div class="laporan-pendapatan-wrapper">
    <b-row>
      <b-col md="12">
        <b-row>
          <b-col md="6" class="text-left">
            <p class="font-weight-bold">
              Laporan Pendapatan
            </p>
          </b-col>
          <b-col md="6" class="text-right">
            <b-button variant="primary" size="sm" class="text-capitalize" @click="download">Download</b-button>
          </b-col>
        </b-row>
        <b-row class="align-items-center mt-2 mb-2">
          <b-col md="6">
            <b-row>
              <b-col sm="4" lg="4">
                <p class="text-capitalize m-0">periode</p>
              </b-col>
              <b-col sm="4" lg="4">
                <b-form-select size="sm" v-model="periodeSelected" :options="filterPeriode"></b-form-select>
              </b-col>
              <b-col md="8" class="mt-2 text-right" v-if="selectedPeriodeRange">
                <DatePickerX v-model="dateRange" is-range :input-props="{placeholder: 'Pilih Tanggal', readonly: true}" :masks="{input: 'DD-MM-YYYY'}" :max-date="maxDate" :min-date="minDate">
                    <template v-slot="{ inputValue, inputEvents }">
                      <div class="flex justify-center items-right">
                        <template v-if="dateRange">
                          <input
                            readonly
                            :value="inputValue.start + ' - ' + inputValue.end"
                            v-on="inputEvents.start"
                            style="border: 1px solid #d1d2db !important"
                            class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                          />
                        </template>
                        <template v-else>
                          <input
                            readonly
                            placeholder="Pilih Tanggal"
                            v-on="inputEvents.start"
                            class="border px-2 py-1 w-32 rounded focus:outline-none focus:border-indigo-300"
                          />
                        </template>
                      </div>
                    </template>
                  </DatePickerX>
              </b-col>
              <b-col sm="12">
                <small class="font-italic" style="color: red">
                  *Data yang ditampilkan maksimal 3 bulan terakhir
                </small>
              </b-col>
            </b-row>
          </b-col>

          <b-col md="6">
            <b-row class="mb-2">
              <b-col sm="4" lg="7" class="text-right-lg">PERIODE</b-col>
              <b-col sm="8" lg="5">
                <b-form-input class="text-right" size="sm" disabled
                  :value="periodeX({ periode: periodeSelected, rawValue: true })" />
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="4" lg="7" class="text-right-lg">TOTAL PASIEN</b-col>
              <b-col sm="8" lg="5">
                <b-form-input class="text-right" size="sm" disabled :value="totalPasienValue" />
              </b-col>
            </b-row>
            <b-row class="mb-2">
              <b-col sm="4" lg="7" class="text-right-lg">TOTAL PENDAPATAN</b-col>
              <b-col sm="8" lg="5">
                <b-form-input class="text-right" size="sm" disabled :value="totalPendapatanValue" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <DataTableWrapper :perPage="perPage" :currentPage="currentPage" :customPagingClass="['custom-pagination']"
      :customEntryOptions="{ f: 5 }" dropdownSizeProps="sm"
      :rows="rows" :fromPage="fromPage" :toPage="toPage"
      @pageChanged="handleValueChanged">
      <b-table id="report-revenue-table" :items="dataList" :fields="fieldList" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :no-local-sorting="true" :responsive="true">
        <template v-slot:head()="data">
          {{ data.label }}
          <b-input size="sm" class="mt-2 w-95" v-if="data.field.searchable"
            @input="searchValueChanged($event, data.field.key)" />
        </template>

        <template v-slot:cell()="data">
          <template v-if="
              data.item.leaveBlank &&
                data.field.key &&
                data.field.key.toLowerCase() !== 'no'
            ">
            <b-input size="sm" class="mt-2 w-95" @input="searchValueChanged($event, data.field.key)" />
          </template>
          <div class="text-wrap text-break" v-else>
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(jenis_kelamin)="data">
          {{ jenisKelamin(data.value) }}
        </template>
      </b-table>
    </DataTableWrapper>
  </div>
</template>

<script>
  
  import moment from "moment";
  import debounce from "lodash/debounce";
  import startCase from "lodash/startCase";
  import {
    DatePicker
  } from "element-ui";
  import lang from "element-ui/lib/locale/lang/en";
  import locale from "element-ui/lib/locale";
  import { mapGetters } from "vuex";

  locale.use(lang);

  export default {
    components: {
      // DatePicker,
      DataTableWrapper: () => import("../../components/DataTableWrapper2"),
      // "vue-select": () => import("vue-select"),
      // CalendarX: () => import('v-calendar/lib/components/calendar.umd'),
      DatePickerX: () => import('v-calendar/lib/components/date-picker.umd')
    },
    data() {
      return {
        sortBy: "",
        sortDesc: false,
        currentPage: 1,
        perPage: 10,
        periodeSelected: "now",
        dateRange: null,
        periodeValue: null,
        totalPasienValue: null,
        totalPendapatanValue: null,
        searchValue: [],
        dataList: [],
        diagnosisList: [],
        selectedDiagnosis: null,
        fromPage: 0,
        toPage: 0,
        totalEntries: 0,
        rows: 0
      };
    },
    computed: {
      ...mapGetters(["getKlinikId"]),
      minDate() {
        return moment().subtract(3, 'months').toDate();
      },
      maxDate() {
        return moment().toDate()
      },
      selectedPeriodeRange() {
        const {
          periodeSelected
        } = this;
        return /(custom)/gi.test(periodeSelected);
      },
      filterPeriode() {
        return [
          {
            value: 'now',
            text: 'Hari Ini'
          },
          {
            value: 'week',
            text: 'Minggu Ini'
          },
          {
            value: 'month',
            text: 'Bulan Ini'
          },
          {
            value: 'custom',
            text: 'Pilih Tanggal'
          },
        ];
      },
      fieldList() {
        const {
          generateFieldList: g,
          setSearchableAndSortableFieldList: s
        } = this;

        const fields = [{
            key: "no"
          },
          {
            key: "waktu_konsultasi",
            label: "waktu konsultasi",
            sortable: true
          },
          {
            key: "nama_dokter",
            label: "nama dokter",
            sortable: true
          },
          {
            key: "nama_klinik",
            label: "nama klinik",
            sortable: true
          },
          {
            key: "nama_poli",
            label: "nama poli",
            sortable: true
          },
          {
            key: "nomor_rekam_medis",
            label: "no. rekam medis",
            thStyle: "width: 150px",
            sortable: true
          },
          {
            key: "total_net",
            label: "jumlah transaksi",
            thStyle: "width: 160px",
            sortable: true
          }
        ];

        return (fields |>
            (z => g({
              field: z
            }))

        );
      }
    },
    watch: {
      // currentPage() {
      //   this.fetchData();
      // },
      // perPage() {
      //   this.fetchData();
      // },
      sortBy() {
        this.fetchData();
      },
      sortDesc() {
        this.fetchData();
      },
      searchValue: {
        handler: "fetchData",
        deep: true
      },
      selectedDiagnosis: {
        handler: function(val) {
          this.diagnosisList = [val];
          this.fetchData()
        },
        deep: true
      },
      periodeSelected(val) {
        if (val !== "custom") {
          this.fetchData();
        }
      },
      dateRange: {
        handler: function () {
          if (this.periodeSelected === "custom") {
            this.fetchData();
          }
        },
        deep: true
      }
    },
    mounted() {
      this.fetchData();
    },
    methods: {
      disabledDate(val) {
        const monthsBefore = moment(val).diff(moment(), "months", true);
        return !(
          moment(val).diff(moment(), "months", true) |> (x => x < 1 && x >= -3.0 && moment(val).isSameOrBefore(moment()))
        );
      },
      detailDiagnosis({
        pembayaran_id
      } = {}) {
        if (pembayaran_id) {
          const {
            dataList
          } = this;
          const {
            diagnosis_icd_x
          } = dataList.find(
            item => item.pembayaran_id === pembayaran_id
          );
          return diagnosis_icd_x;
        }
      },
      searchValueChanged: debounce(function (val, key) {
        const {
          searchValue
        } = this;
        const z = searchValue.filter(item => item.key !== key);
        this.searchValue = [
          ...z,
          {
            key,
            value: val
          }
        ];
      }, 500),
      periodeX({
        periode = null,
        rawValue = false
      } = {}) {
        const formatBackendDate = "YYYY-MM-DD";
        const rawValueFormat = "DD-MMM-YYYY";
        switch (periode && periode.toLowerCase()) {
          case "custom":
            const {
              dateRange
            } = this;
            if (dateRange) {
              const {start: startDate, end: endDate} = dateRange;
              const formatDate = "DD-MM-YYYY";
              if (rawValue) {
                return `${moment(startDate, formatDate).format(
                rawValueFormat
              )}-${moment(endDate, formatDate).format(rawValueFormat)}`;
              } else {
                return `&from=${moment(startDate, formatDate).format(
                formatBackendDate
              )}&to=${moment(endDate, formatDate).format(formatBackendDate)}`;
              }
            } else {
              return null;
            }

            case "now":
              const today = moment().format(formatBackendDate);
              return rawValue ?
                moment().format(rawValueFormat) :
                Array(2)
                .fill(today)
                .map(
                  (val, index) =>
                  `&${(item => (item ? "to" : "from"))(index)}=${val}`
                )
                .join("");

            case "week":
              const startWeek = moment().weekday(0);
              const endWeek = moment().weekday(6);
              return rawValue ?
                `${startWeek.format(rawValueFormat)}-${endWeek.format(
                rawValueFormat
              )}` :
                `&from=${startWeek.format(formatBackendDate)}&to=${endWeek.format(
                formatBackendDate
              )}`;

            case "month":
              const startMonth = moment().date(1);
              const endMonth = moment().date(31);
              return rawValue ?
                `${startMonth.format(rawValueFormat)}-${endMonth.format(
                rawValueFormat
              )}` :
                `&from=${startMonth.format(
                formatBackendDate
              )}&to=${endMonth.format(formatBackendDate)}`;

            default:
              break;
        }
      },
      handleValueChanged({perPage, currentPage}) {
        if(this.perPage) this.perPage = perPage;
        if(this.perPage) this.currentPage = currentPage;
        this.fetchData();
      },
      onSearch(val) {
        this.search(val, this);
      },
      determineParameter() {
        const {
          periodeX,
          periodeSelected: periode,
          sortBy,
          sortDesc,
          searchValue,
          selectedDiagnosis
        } = this;
        const r = new RegExp("diagnosis", "gi");
        const v = "kode_penyakit_id";
        let tmp = "";
        tmp += `${periodeX({ periode })}`;
        searchValue.map(item => {
          const x =
            (item.key === "nama" && "nama_pasien") ||
            (r.test(item.key) && v) ||
            item.key;
            tmp += `&${x}=${item.value}`;
        });

        tmp += `&periode=${periode}`

        if (sortBy) {
          tmp += `&column=${r.test(sortBy) ? v : sortBy}&order=${
          sortDesc ? "desc" : "asc"
        }`;
        }

        return tmp;
      },
      async fetchData() {
        try {
          const {
            searchValue,
            determineParameter
          } = this;
          const res = await this.$axios.get(
            `dash-pendapatan?klinik_id=${this.getKlinikId}&is_owner=true&limit=${this.perPage}&page=${this.currentPage}${determineParameter()}`
          );
          if (res.data.success) {
            const {
              data: listLaporanPendapatan,
              total: totalEntries,
              to: toPage,
              from: fromPage
            } = res.data.data;

            const copyObj = Object.assign({}, listLaporanPendapatan[0]);
            const tmp = Object.keys(copyObj).map(item => {
              copyObj[item] = null;
            });
            const tmpList = [
              ...listLaporanPendapatan.map((item, index) => ({
                ...item,
                waktu_konsultasi: (e =>
                  moment(e, "YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY HH:mm:ss"))(
                  item.waktu_konsultasi
                ),
                total_net: this.formatHarga(item.total_net),
                no: (this.currentPage - 1) * this.perPage + index + 1
              }))
            ];

            this.dataList = (tmpList &&
              tmpList.length > 0 && [
                Object.assign(copyObj, {
                  leaveBlank: true
                }),
                ...tmpList
              ]) || [...tmpList, {
              leaveBlank: true
            }];

            this.rows = totalEntries;
            this.totalEntries =  totalEntries;
            this.toPage = toPage;
            this.fromPage = fromPage;

            this.totalPasienValue = res.data.total_pasien + ' orang';
            this.totalPendapatanValue = this.formatHarga(res.data.sum_data);
            // this.periodeValue = res.data.periode;
            return this;
          }
        } catch (err) {
          // console.log(err);
        }
      },
      async download() {
        try {
          const res = await this.$axios.get(
            `dash-pendapatan/export?klinik_id=${this.getKlinikId}&is_owner=true&is_export=true${this.determineParameter()}`);
          
          window.open(res.data.data.link, '_blank');

          // const url = window.URL.createObjectURL(new Blob([res.data]));
          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', 'Laporan-Pendapatan.xlsx');
          // document.body.appendChild(link);
          // link.click();
        } catch (err) {
          // console.log(err);
        }
      },
      formatHarga(num) {
        return "Rp " + num.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1\.")
      },
    }
  };
</script>

<style lang="scss">
  $baseBgColor: #fff;
  $evenBgColor: #f9f9f9;

  .laporan-pendapatan-wrapper {
    $border-radius: 12px;
    border-top-left-radius: $border-radius;
    border-top-right-radius: $border-radius;
    background-color: $baseBgColor;
    color: #4c6e8a !important;

    section {
      table {
        thead {
          tr {
            th {
              background-color: transparent !important;
              color: #4c6e8a !important;
              border: none !important;
            }
          }
        }

        tbody {
          tr {
            &:nth-child(even) {
              background-color: #f9f9f9;
            }
          }
        }
      }
    }

    .el-range-separator {
      width: 35px;
    }
  }

  .custom-v-select {
    .vs__dropdown-toggle {
      max-height: 29.94px;
      background-color: #fff;
      overflow: hidden;
    }

    .vs__dropdown-menu {
      width: auto !important;
    }
  }

  #report-revenue-table {
    thead th {      
      vertical-align: middle !important;
    }
  }

  @media screen and (min-width: 993px) {
    .text-right-lg {
      text-align: right;
    }
  }
</style>
